import { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useAuthContext } from '../../../hooks/AuthContext'
import Loader from './Loader'

const ProtectedPage = (WrappedComponent) => {
  const ProtectedComponent = (props) => {
    const Router = useRouter()
    const { state } = useAuthContext()

    useEffect(() => {
      if (state.isLoading) {
        return
      }

      if (!state.isAuth && Router.pathname !== '/login') {
        Router.replace('/login')
        return
      }

      if (state.isAuth && state.userType === 'none' && Router.pathname !== '/login/role') {
        Router.replace('/login/role')
      }
    }, [Router, Router.pathname, state.isAuth, state.isLoading, state.userType])

    if (!state.isLoading && !state.isAuth) {
      return <Loader />
    }

    if (state.isLoading) {
      return <Loader />
    }

    if (state.userType === 'none') {
      return <Loader />
    }

    if (state.isAuth) {
      return <WrappedComponent {...props} />
    }

    return <p>Unexpected state, please check authentication status.</p>
  }

  return ProtectedComponent
}

export default ProtectedPage
